// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper-b46845c8"};